import { createMuiTheme } from "@material-ui/core/styles";
import { COLORS, FONTS, FONTWEIGHT } from "./constants";

export const theme = createMuiTheme({
  typography: {
    h1: {
      fontFamily: `${FONTS.PRIMARY}, ${FONTS.DEFAULT}`,
      fontSize: "32px",
      lineHeight: "60px",
      color: "#212934",
      justifyContent: "center",
    },
    h2: {
      fontFamily: `${FONTS.PRIMARY}, ${FONTS.DEFAULT}`,
      fontWeight: FONTWEIGHT.MEDIUM,
      fontSize: "32px",
      lineHeight: "48px",
      color: COLORS.BLACK,
    },
    h3: {
      fontFamily: `${FONTS.PRIMARY}, ${FONTS.DEFAULT}`,
      fontSize: "18px",
      color: COLORS.DARKGREY,
    },
    h4: {
      fontFamily: `${FONTS.PRIMARY}, ${FONTS.DEFAULT}`,
      fontWeight: FONTWEIGHT.MEDIUM,
      fontSize: "18px",
      lineHeight: "27px",
      color: COLORS.BLACK,
    },
    h5: {
      fontFamily: `${FONTS.PRIMARY}, ${FONTS.DEFAULT}`,
      fontWeight: FONTWEIGHT.MEDIUM,
      fontSize: "18px",
      color: COLORS.WHITE,
    },
    h6: {
      fontFamily: `${FONTS.PRIMARY}, ${FONTS.DEFAULT}`,
      fontSize: "13px",
      color: COLORS.DARKGREY,
    },
  },
  overrides: {
    MuiTooltip: {
      popper: {
        zIndex: "100000",
      },
      tooltip: {
        fontFamily: `${FONTS.SECONDARY}, ${FONTS.DEFAULT}`,
        padding: "12px 18px",
        borderRadius: "2px",
        backgroundColor: "#212934",
        color: "#fff",
        fontSize: "15px",
        lineHeight: "20px",
      }
    }
  }
});
